(function () {
  function closePicker(list) {
    list.classList.add('closed');
    list.classList.remove('opened');

    const wrapper = list.closest('[data-diamond-gallery-picker]');
    const valueEl = wrapper && wrapper.querySelector('[data-diamond-picker-value]');
    const icon = valueEl && valueEl.querySelector('svg');

    if (valueEl) valueEl.style.borderBottom = 'none';
    if (icon) icon.style.transform = 'rotate(90deg)';
  }

  function openPicker(list) {
    list.classList.add('opened');
    list.classList.remove('closed');

    const wrapper = list.closest('[data-diamond-gallery-picker]');
    const valueEl = wrapper && wrapper.querySelector('[data-diamond-picker-value]');
    const icon = valueEl && valueEl.querySelector('svg');

    if (valueEl) valueEl.style.borderBottom = '1px solid #3E272326';
    if (icon) icon.style.transform = 'rotate(270deg)';
  }

  function closeAllPickers() {
    document.querySelectorAll('.diamond-gallery-picker-list.opened').forEach(closePicker);
  }

  function updateValueText(wrapper) {
    const valueTextEl = wrapper.querySelector('[data-diamond-picker-value-text]');
    if (!valueTextEl) return;

    const selectedTitles = Array.from(
      wrapper.querySelectorAll('[data-diamond-picker-item].is-selected')
    ).map((item) => item.getAttribute('data-diamond-title'));

    valueTextEl.textContent = selectedTitles.length
      ? selectedTitles.join(', ')
      : valueTextEl.getAttribute('data-default-value') || '';
  }

  function filterItems(wrapper, query) {
    const normalizedQuery = query.trim().toLowerCase();

    wrapper.querySelectorAll('[data-diamond-picker-item]').forEach((item) => {
      const matches = !normalizedQuery || item.textContent.toLowerCase().indexOf(normalizedQuery) !== -1;
      item.classList.toggle('is-hidden', !matches);
    });
  }

  // Delegated on document so this keeps working after Dawn swaps <variant-selects>
  // markup during an AJAX variant update, and regardless of any other DOM replacement
  // around this picker.

  document.addEventListener('click', function (e) {
    const item = e.target.closest('[data-diamond-picker-item]');
    if (item) {
      if (e.target.closest('a')) return;

      const wrapper = item.closest('[data-diamond-gallery-picker]');
      if (!wrapper) return;

      item.classList.toggle('is-selected');
      updateValueText(wrapper);
      return;
    }

    if (e.target.closest('[data-diamond-picker-search]')) return;

    const valueEl = e.target.closest('[data-diamond-picker-value]');
    if (valueEl) {
      const wrapper = valueEl.closest('[data-diamond-gallery-picker]');
      const list = wrapper && wrapper.querySelector('.diamond-gallery-picker-list');
      if (!list) return;

      const isOpen = list.classList.contains('opened');
      closeAllPickers();

      if (!isOpen) {
        document.dispatchEvent(new CustomEvent('product-dropdown:open', { detail: { source: list } }));
        openPicker(list);
      }
      return;
    }

    if (!e.target.closest('[data-diamond-gallery-picker]')) {
      closeAllPickers();
    }
  });

  document.addEventListener('input', function (e) {
    const searchInput = e.target.closest('[data-diamond-picker-search]');
    if (!searchInput) return;

    const wrapper = searchInput.closest('[data-diamond-gallery-picker]');
    if (wrapper) filterItems(wrapper, searchInput.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPickers();
  });

  document.addEventListener('product-dropdown:open', function (e) {
    document.querySelectorAll('.diamond-gallery-picker-list.opened').forEach(function (list) {
      if (list !== e.detail.source) closePicker(list);
    });
  });
})();
